export type EndpointDefinition = [
  'get' | 'post' | 'put' | 'patch' | 'delete',
  string,
];

const endpoints: { [key: string]: EndpointDefinition } = {
  mapSearchQueryByBoundingBoxAndType: [
    'post',
    '/public/app-main/api/map-search-query-by-bounding-box-and-type',
  ],
  signalPositions: ['post', '/public/app-main/api/signal/positions'],
  signalPosition: ['get', '/public/app-main/api/signal/positions/:id'],
  getMyPositions: ['get', '/public/app-main/api/signal/my-positions'],
  signalCreateShareWithMember: ['post', '/public/app-main/api/signal/share'],
  signalShares: ['get', '/public/app-main/api/signal/share'],
  signalDeleteShare: ['delete', '/public/app-main/api/signal/share'], // deletes don't do URL segment replacing in the `callEndpoint` function, so just use this, and append the ID when using it ;(
  mapSearchQueryById: ['post', '/public/app-main/api/map-search-query-by-id'],
  commentByParentId: ['post', '/public/app-main/api/comment-by-parent-id'],
  queryAis: ['post', '/public/app-main/api/query-ais'],
  logout: ['post', '/public/app-main/api/logout'],
  requestValidationOfClientTokenViaEmailToken: [
    'post',
    '/public/app-main/api/request-validation-of-client-token-via-email-token',
  ],
  validateClientTokenViaEmailToken: [
    'post',
    '/public/app-main/api/validate-client-token-via-email-token',
  ],
  checkClientToken: ['post', '/public/app-main/api/check-client-token'],
  unsubscribeFromEmail: ['post', '/public/app-main/api/unsubscribe-from-email'],
  createComment: ['post', '/public/app-main/api/create-comment'],
  collect: ['post', '/public/app-main/api/collect'],
  submitMarker: ['post', '/public/app-main/api/submit-marker'],
  editMarker: ['post', '/public/app-main/api/edit-marker'],
  flagMarker: ['post', '/public/app-main/api/flag-marker'],
  submitSupportRequest: ['post', '/public/app-main/api/submit-support-request'],
  updateProfile: ['post', '/public/app-main/api/update-profile'],
  checkUpVotes: ['post', '/public/app-main/api/check-up-votes'],
  queryWeather: ['post', '/public/app-main/api/query-weather'],
  queryWeatherSummary: ['get', '/public/app-main/api/weather/summary'],
  queryWeatherCurrentConditions: [
    'get',
    '/public/app-main/api/weather/current-conditions',
  ],
  queryWeatherMoonPhases: ['get', '/public/app-main/api/weather/moon-phases'],
  queryWeatherOutlook: ['get', '/public/app-main/api/weather/outlook'],
  queryWeatherForecastGraphData: [
    'get',
    '/public/app-main/api/weather/forecast/graph',
  ],
  queryNearbyWeatherStations: ['get', '/public/app-main/api/weather/stations'],
  weatherStationsSearch: [
    'get',
    '/public/app-main/api/weather/stations/search',
  ],
  getWarnings: ['get', '/public/app-main/api/warnings'],
  getWarning: ['get', '/public/app-main/api/warnings/:id'],
  setUserTagsInRegionUnavailable: [
    'post',
    '/public/app-main/api/set-user-tags-in-region-unavailable',
  ],
  locationsSearch: ['post', '/public/app-main/api/locations-search'],
  reverseGeocodingAddressLookup: [
    'post',
    '/public/app-main/api/reverse-geocoding-address-lookup',
  ],
  locationsRetrieveDataForPlaceId: [
    'post',
    '/public/app-main/api/locations-retrieve-data-for-place-id',
  ],
  submitMemberInterests: [
    'post',
    '/public/app-main/api/submit-member-interests',
  ],
  getMemberInterests: ['get', '/public/app-main/api/get-member-interests'],
  getMember: ['post', '/public/app-main/api/get-member-details'],
  getMemberByEmail: ['post', '/public/app-main/api/get-member-by-email'],
  addWatercraft: ['post', '/public/app-main/api/add-watercraft'],
  getMemberWatercrafts: ['post', '/public/app-main/api/get-member-watercrafts'],
  getRadioRanges: [
    'get',
    '/public/app-main/api/radio-ranges/:latitude/:longitude',
  ],
  getWatercraft: ['post', '/public/app-main/api/get-watercraft'],
  editWatercraft: ['post', '/public/app-main/api/edit-watercraft'],
  hideWatercraft: ['delete', '/public/app-main/api/hide-watercraft'],
  getInterests: ['get', '/public/app-main/api/get-interests'],
  submitReminder: ['post', '/public/app-main/api/submit-reminder'],
  getReminders: ['get', '/public/app-main/api/get-reminders'],
  editReminder: ['post', '/public/app-main/api/edit-reminder'],
  deleteReminder: ['delete', '/public/app-main/api/delete-reminder'],
  getWeatherLocationFavourites: [
    'get',
    '/public/app-main/api/get-weather-location-favourites',
  ],
  addWeatherLocationFavourite: [
    'post',
    '/public/app-main/api/add-weather-location-favourite',
  ],
  deleteWeatherLocationFavourite: [
    'delete',
    '/public/app-main/api/delete-weather-location-favourite',
  ],
  isUsernameAvailable: ['post', '/public/app-main/api/is-username-available'],
  sendExpiringReminderEmails: [
    'post',
    '/private/send-expiring-reminder-emails',
  ],
  submitStoryMarker: ['post', '/public/app-main/api/submit-story-marker'],
  getStoryMarkers: ['get', '/public/app-main/api/get-story-markers'],
  editStoryMarker: ['post', '/public/app-main/api/edit-story-marker'],
  hideStoryMarker: ['post', '/public/app-main/api/hide-story-marker'],
  submitMemberStory: ['post', '/public/app-main/api/submit-member-story'],
  getMemberStories: ['post', '/public/app-main/api/get-member-stories'],
  editMemberStory: ['post', '/public/app-main/api/edit-member-story'],
  hideMemberStory: ['post', '/public/app-main/api/hide-member-story'],
  getRSSFeed: ['get', '/public/app-main/api/recent-markers.rss'],
  getHomeLocation: ['get', '/public/app-main/api/get-home-location'],
  submitMemberHomeLocation: [
    'post',
    '/public/app-main/api/submit-member-home-location',
  ],
  deleteAccount: ['delete', '/public/app-main/api/delete-account'],
  getMemberProfileProgress: [
    'get',
    '/public/app-main/api/get-member-profile-progress',
  ],
  getTrips: ['post', '/public/app-main/api/get-trips'],
  getActiveTrip: ['get', '/public/app-main/api/get-active-trip-details'],
  getTripDetails: ['post', '/public/app-main/api/get-trip-details'],
  getTripTrackPoints: ['post', '/public/app-main/api/get-trip-track-points'],
  startTrip: ['post', '/public/app-main/api/start-trip'],
  stopTrip: ['post', '/public/app-main/api/stop-trip'],
  updateTripDetails: ['post', '/public/app-main/api/update-trip-details'],
  hideTrip: ['post', '/public/app-main/api/hide-trip'],
  logTrackPoint: ['post', '/public/app-main/api/log-track-point'],
  pauseResumeTrip: ['post', '/public/app-main/api/pause-resume-trip'],
  submitTripPlan: ['post', '/public/app-main/api/submit-trip-plan'],
  editTripPlan: ['post', '/public/app-main/api/edit-trip-plan'],
  setTripPlanEmergency: [
    'post',
    '/public/app-main/api/set-trip-plan-emergency',
  ],
  logOffTrip: ['post', '/public/app-main/api/log-off-trip'],
  getTripPlanDetails: ['post', '/public/app-main/api/get-trip-plan-details'],
  getActiveTripPlans: ['post', '/public/app-main/api/get-active-trip-plans'],
  readNotification: ['post', '/public/app-main/api/alerts/read'],
  hideAlertNotification: ['post', '/public/app-main/api/alerts/hide'],
  getAlerts: ['get', '/public/app-main/api/alerts'],
  getAlert: ['get', '/public/app-main/api/alerts/:id'],
  uploadDataCaptureEvents: [
    'post',
    '/public/app-main/api/upload-data-capture-events',
  ],
  addSharingActivity: ['post', '/public/app-main/api/add-sharing-activity'],
  searchForUsers: ['get', '/public/app-main/api/users/search'],
  getSharingActivitiesByMember: [
    'get',
    '/public/app-main/api/get-sharing-activity-by-member',
  ],

  checkForNewSharingActivities: [
    'get',
    '/public/app-main/api/check-for-new-sharing-activities',
  ],
  updateSharingActivitiesReadStatusByMember: [
    'get',
    '/public/app-main/api/update-sharing-activity-read-status-by-member',
  ],
  updateLastActive: ['post', '/public/app-main/api/update-last-active'],

  getFloatPlan: ['post', '/public/app-main/api/get-float-plan'],
  getFloatPlanByToken: ['post', '/public/app-main/api/get-float-plan-by-token'],
  getFloatPlans: ['post', '/public/app-main/api/get-float-plans'],
  getFloatPlanByTrip: ['post', '/public/app-main/api/get-float-plan-by-trip'],
  getActiveFloatPlan: ['post', '/public/app-main/api/get-active-float-plan'],
  createFloatPlan: ['post', '/public/app-main/api/create-float-plan'],
  updateFloatPlan: ['post', '/public/app-main/api/update-float-plan'],
  cancelFloatPlan: ['post', '/public/app-main/api/cancel-float-plan'],
  endFloatPlan: ['post', '/public/app-main/api/end-float-plan'],
  getFloatPlanLastSharedWith: [
    'post',
    '/public/app-main/api/get-float-plan-last-shared-with',
  ],
  getExistingFloatPlanContacts: [
    'post',
    '/public/app-main/api/get-existing-float-plan-contacts',
  ],
  updateMemberContactInformation: [
    'post',
    '/public/app-main/api/update-member-contact-information',
  ],
  addOrUpdateMemberSettings: [
    'post',
    '/public/app-main/api/add-or-update-member-settings',
  ],
  getMemberSettings: ['post', '/public/app-main/api/get-member-settings'],

  submitIncidentReport: ['post', '/public/app-main/api/incidents'],

  getRegulationById: ['get', `/public/app-main/api/regulations/:id`],

  getRegulationsByLocation: [
    'get',
    `/public/app-main/api/regulations/:latitude/:longitude`,
  ],

  getRegulationsCountByLocation: [
    'get',
    `/public/app-main/api/regulations/:latitude/:longitude/count`,
  ],
  getFollowsForMember: [
    'get',
    `/public/app-main/api/members/:memberId/follows`,
  ],
  createFollowForMember: [
    'post',
    `/public/app-main/api/members/:memberId/follows`,
  ],
  unfollowMember: ['delete', `/public/app-main/api/follows/:followId`],
  requestEmailChangeReauth: [
    'post',
    '/public/app-main/api/request-email-change-reauth',
  ],
  verifyEmailChangeReauth: [
    'post',
    '/public/app-main/api/verify-email-change-reauth',
  ],
  requestEmailChange: ['post', '/public/app-main/api/request-email-change'],
  confirmEmailChange: ['post', '/public/app-main/api/confirm-email-change'],
  emailChangeReauthStatus: [
    'get',
    '/public/app-main/api/email-change-reauth-status',
  ],
  waterBodyDefinitionFromLocation: [
    'post',
    '/public/app-main/api/marketplace/water-body-definition-from-location',
  ],
};

export default endpoints;
